import { OFACScreeningStatusEnum } from 'anchor-kyb-service/types';
import React, { useMemo, useState } from 'react';
import { Redirect, useLocation } from 'react-router';
import { Spinner, useOverlayContext } from 'seagull';
import GenericError from "../../components/GenericError/GenericError";
import RestfulWrapper from "../../components/RestfulWrapper/RestfulWrapper";
import { routes } from "../../constants";
import { useIoContext, useStoreActions } from "../../contexts";
import { useOnMount } from "../../hooks/useOnMount";
import { LatestOFACSanctionStatusModel } from "../../models";
const renderLoader = () => /*#__PURE__*/React.createElement(Spinner, {
  "data-testid": "loading-ofac-data",
  centeredInBox: true,
  centerBoxHeight: "100%"
});
const renderError = () => /*#__PURE__*/React.createElement(GenericError, {
  testid: "ofac-error"
});
function RedirectToHome(_ref) {
  let {
    detailsAdded
  } = _ref;
  const {
    showSuccessToast
  } = useOverlayContext();
  useOnMount(() => {
    if (detailsAdded) {
      showSuccessToast('The additional details have been successfully added.', 'details-added');
    }
  });
  return /*#__PURE__*/React.createElement(Redirect, {
    to: routes.home
  });
}
function OpenPersonaInquiry(_ref2) {
  let {
    inquiryId,
    sessionToken
  } = _ref2;
  const {
    personaClient,
    locationReload
  } = useIoContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [complete, setComplete] = useState(false);
  const persona = useMemo(() => {
    return personaClient({
      onError: () => setError(true),
      onReady: () => setLoading(false),
      onComplete: () => setComplete(true),
      onCancel: () => locationReload()
    });
  }, []);
  useOnMount(() => {
    persona.open(inquiryId, sessionToken);
  });
  return error ? renderError() : loading ? renderLoader() : complete ? /*#__PURE__*/React.createElement(RedirectToHome, {
    detailsAdded: true
  }) : null;
}
export async function fetchInquiry(_ref3) {
  let {
    data,
    getUserStatus,
    getBusinessStatus,
    createInquiry
  } = _ref3;
  const defaultStatus = new LatestOFACSanctionStatusModel({
    status: OFACScreeningStatusEnum.Cleared
  });
  const userStatusPromise = data.user.isSanctioned ? getUserStatus(data.user.id) : Promise.resolve(defaultStatus);
  const businessStatusPromise = data.business.isSanctioned ? getBusinessStatus(data.business.id) : Promise.resolve(defaultStatus);
  const [userStatus, businessStatus] = await Promise.all([userStatusPromise, businessStatusPromise]);
  const inquiryPayload = {
    userId: userStatus.requiresInquiry() ? data.user.id : undefined,
    businessId: businessStatus.requiresInquiry() ? data.business.id : undefined
  };
  if (inquiryPayload.userId || inquiryPayload.businessId) {
    const inquiry = await createInquiry(inquiryPayload);
    return {
      inquiry
    };
  } else {
    return {
      inquiry: null
    };
  }
}
export default function AdditionalPaymentProcessorInfoPage() {
  const {
    state
  } = useLocation();
  const {
    api
  } = useStoreActions();
  return state ? /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: async () => fetchInquiry({
      data: state.data,
      getUserStatus: userId => api.ofacScreening.getUserStatus(userId),
      getBusinessStatus: businessId => api.ofacScreening.getBusinessStatus(businessId),
      createInquiry: api.ofacScreening.createInquiry
    }),
    renderChild: _ref4 => {
      let {
        data
      } = _ref4;
      return data.inquiry ? /*#__PURE__*/React.createElement(OpenPersonaInquiry, data.inquiry) : /*#__PURE__*/React.createElement(RedirectToHome, {
        detailsAdded: true
      });
    },
    renderLoader: renderLoader,
    renderError: renderError
  }) : /*#__PURE__*/React.createElement(RedirectToHome, null);
}